import { apiRequest } from '../../utils/axios'

export async function fetchPrintQueueCount(token: string): Promise<number> {
  return apiRequest('GET', '/admin/printQueueCount', token)
}
